import React from 'react'
import cx from 'classnames'
import { BtnV2 } from '@manychat/manyui'

import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

import { ConsentPromptProps } from './types'

import cm from './ConsentPrompt.module.css'

export const ConsentPrompt = ({
  title,
  description,
  content,
  confirm,
  close,
  className,
  mountEvent,
  unmountEvent,
}: ConsentPromptProps) => {
  const promptClassName = cx(cm.root, className)

  useDidMountEffect(() => {
    if (mountEvent) {
      analyticsService.sendEvent(mountEvent)
    }

    return () => {
      if (unmountEvent) {
        analyticsService.sendEvent(unmountEvent)
      }
    }
  })

  return (
    <div role="dialog" data-test-id="consent-prompt" className={promptClassName}>
      {title}
      {description}
      {content}
      {confirm && <BtnV2 onClick={confirm.onClick}>{confirm.text}</BtnV2>}
      {close && (
        <BtnV2 onClick={close.onClick} variant="ghost-dark">
          {close.text}
        </BtnV2>
      )}
    </div>
  )
}
